export function debounce<R, A extends any[]>(
  fn: (...args: A) => R,
  delay: number,
  onFire?: (...args: NoInfer<A>) => void,
) {
  let timer: NodeJS.Timeout;
  return [
    (...args: A) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        onFire?.(...args);
        fn(...args);
      }, delay);
    },
    () => {
      clearTimeout(timer);
    },
  ] as const;
}
